import router from '../../router'
import axios from 'axios'
import config from '../../config'
import { INITIAL_NEW_QUERY } from '../../components/common/searchPropertyConst'
import {
  genericPostRequestToApi,
  genericGetRequestToApi
} from '../../utils/genericRequests'
import {
  RetrieveProfileUrl,
  RetrieveSearchPropertyUrl
} from '../../utils/agentUrls'

const getDefaultCommonState = () => {
  return {
    authStatus: {
      isLoggedIn: false,
      loginError: null,
      errorAlert: false,
      loading: false
    },
    profileStatus: null,
    lastNewQuery: {
      status: false,
      query: { ...INITIAL_NEW_QUERY }
    },
    searchObject: {
      loading: false,
      searchResult: false,
      searchType: 'sale',
      includeType: 0,
      markedId: '',
      markedMarker: -1,
      data: []
    },
    drawer: false,
    searchYOffset: 0,
    selectedHome: {},
    showMobileFeedbackModal: false,
    showSingleRoutePropertyView: false,
    searchInputValues: {},
    routeData: [],
    expandedRoute: {},
    selectedRoute: {},
    selectedRouteLoading: false,
    routeHomes: [],
    isMobile: window.innerWidth < 600,
    loadingRoutes: false,
    addressInputValue: {
      text: '',
      placeholder: 'City, Address, MLS# or Zip',
      suggestion: false
    },
    multipleRequestedObject: {
      City: [],
      PostalCode: [],
      StreetNumber: [],
      StreetName: [],
      MLSNumber: [],
      Keywords: ''
    },
    searchTextParams: {},
    routesLoaded: false,
    refreshSearch: false,
    yScrollPosition: 0,
    doScroll: false,
    selectedFavoritesTab: 0
    // testCityData: []
  }
}

const state = getDefaultCommonState()

const actions = {
  profileLogout({ commit, dispatch }, redirect = true) {
    if (localStorage.getItem('x-authentication')) {
      localStorage.removeItem('x-authentication')
    }
    localStorage.removeItem('profileStatus')
    dispatch('agent/unsubscribe', null, { root: true })
    dispatch('client/unsubscribe', null, { root: true })
    commit('SET_DEFAULT_COMMON_STATE')
    commit('agent/SET_DEFAULT_AGENT_STATE', null, { root: true })
    commit('client/SET_DEFAULT_CLIENT_STATE', null, { root: true })
    if (redirect) {
      router.push({ name: 'login' })
    }
  },

  /**
   * Handles the login authorization for agent's side
   * after validation the input credentials
   *
   * @param {Object} agent consists of agent login input value
   */
  profileLogin({ commit, state }, agent) {
    let messageDelivered = false
    commit('common/SET_LOADING', null, { root: true })
    axios
      .post(`${config.apiUrl}/v1/login`, agent)
      .then(response => {
        const responseData = response.data
        if (responseData['token']) {
          localStorage.setItem(
            'x-authentication',
            JSON.stringify(responseData)
          )

          // Get profile details after setting token
          genericGetRequestToApi(RetrieveProfileUrl()).then(response => {
            if (response.status === 200) {
              if (response.data.agentid) {
                commit('common/SET_PROFILE_STATUS', 'agent', { root: true })
                if (localStorage.homewayzRedirectURL) {
                  router.push({ path: localStorage.homewayzRedirectURL })
                  localStorage.removeItem('homewayzRedirectURL')
                } else if (state.isMobile) {
                  router.push({ name: 'agent-search' })
                } else {
                  router.push({ name: 'Task-Manager / Task-View' })
                }
              } else {
                commit('common/SET_PROFILE_STATUS', 'client', { root: true })
                if (
                  !response.data.homePrefs ||
                  !response.data.homePrefs.options.length
                ) {
                  if (!this.isMobile) {
                    return router.push({ name: 'client-onboarding' })
                  }
                }
                if (localStorage.homewayzRedirectURL) {
                  router.push({ path: localStorage.homewayzRedirectURL })
                  localStorage.removeItem('homewayzRedirectURL')
                } else if (state.isMobile) {
                  router.push({ name: 'client-search' })
                } else {
                  router.push({ name: 'client-dashboard' })
                }
              }
            } else {
              console.log('profile Login error >>> Some error')
            }
            commit(
              'common/SET_LOGIN_STATUS',
              { status: true, message: null, error: false },
              { root: true }
            )
            messageDelivered = true
          })
        }
      })
      .catch(err => {
        if (err.response.status === 401) {
          commit(
            'common/SET_LOGIN_STATUS',
            {
              status: false,
              message: 'Either email or password is incorrect',
              error: true
            },
            { root: true }
          )
          messageDelivered = true
        } else {
          commit(
            'common/SET_LOGIN_STATUS',
            {
              status: false,
              message: 'Unable to process that request',
              error: true
            },
            { root: true }
          )
          messageDelivered = true
        }
        setTimeout(() => {
          commit('common/DEACTIVATE_ERROR_STATUS', null, { root: true })
        }, 5000)
      })
    setTimeout(() => {
      if (!messageDelivered) {
        commit(
          'common/SET_LOGIN_STATUS',
          {
            status: false,
            message: "Couldn't connect to the server at the moment",
            error: true
          },
          { root: true }
        )
      }
    }, 8000)
  },

  /**
   * Retrieves the property lists based on query string
   * Currently it will display all active properties by default
   *
   * @param {Object} searchObject - request body payload for search
   */
  async searchPropertiesList({ commit, state }, payload) {
    const searchElement = payload

    commit('SET_SEARCH_LOADER', true)
    const response = await genericPostRequestToApi(
      RetrieveSearchPropertyUrl(),
      searchElement
    )
    commit('SET_SEARCH_LOADER', false)
    if (response.status === 200) {
      // Debugging search results
      // let cityArray = [...state.testCityData]
      // response.data.forEach(item => {
      //   if (item.StreetSuffix && !cityArray.includes(item.StreetSuffix)) {
      //     cityArray.push(item.StreetSuffix)
      //   }
      // })
      // commit('TEST_CITY_DATA', cityArray)
      commit('SET_SEARCH_DATA', response.data)
    } else if (response.status === 401) {
      router.push({ name: 'login' })
    }
  },

  getRouteData({ commit }, { data, type }) {
    if (data) {
      let routeArray = []
      if (type === 'agent') {
        data.clients.map(client => {
          if (client.routes && client.routes.length > 0) {
            client.routes.forEach(route =>
              routeArray.push({
                ...route,
                clientId: client._id,
                clientName: client.name
              })
            )
          }
        })
      } else if (type === 'client') {
        if (data.routes && data.routes.length > 0) {
          data.routes.forEach(route =>
            routeArray.push({
              ...route,
              clientId: data._id,
              clientName: data.name
            })
          )
        }
      }
      commit('SET_ROUTE_DATA', routeArray)
      commit('ROUTES_LOADED', true)
    }
  },
  setSelectedFavoritesTab({ commit }, selectedFavoritesTab) {
    commit('SET_SELECTED_FAVORITES_TAB', selectedFavoritesTab)
  }
}

const mutations = {
  // **************************************
  // SEARCH RELATED MUTATIONS
  // **************************************
  // TEST_CITY_DATA: (state, value) => {
  //   state.testCityData = value
  // },

  SET_SEARCH_LOADER: (state, payload) => {
    Object.assign(state.searchObject, {
      loading: payload
    })
  },

  SET_SEARCH_DATA: (state, payload) => {
    if (state.searchObject.data.length > 0) {
      state.searchObject.data.push(...payload)
    } else {
      Object.assign(state.searchObject, {
        data: payload
      })
    }
  },

  SET_SEARCH_OBJECT_DATA: (state, payload) => {
    Object.assign(state.searchObject, {
      data: payload
    })
  },

  SET_SEARCH_Y_OFFSET: (state, payload) => {
    state.searchYOffset = payload
  },
  SET_Y_SCROLL_POSITION: (state, payload) => {
    state.yScrollPosition = payload
  },
  REFRESH_SEARCH_DATA: state => {
    Object.assign(state.searchObject, {
      data: []
    })
  },

  REFRESH_SEARCH_OBJECT: state => {
    state.searchObject = { ...getDefaultCommonState().searchObject }
  },

  SET_SEARCH_LAYOUT_TYPE: (state, layoutType) => {
    state.searchObject.searchType = layoutType
  },

  SET_SEARCH_INCLUDE_TYPE: (state, typeValue) => {
    state.searchObject.includeType = typeValue
  },

  SET_SEARCH_RESULT_PAGE: (state, setResult) => {
    state.searchObject.searchResult = setResult
  },

  SET_MARKED_ID: (state, propertyId) => {
    state.searchObject.markedId = propertyId
  },

  SET_MARKED_MARKER: (state, propertyIndex) => {
    state.searchObject.markedMarker = propertyIndex
  },

  SET_ADDRESS_INPUT_VALUE: (state, inputValue) => {
    state.addressInputValue = { ...state.addressInputValue, ...inputValue }
  },

  SET_MULTIPLE_REQUESTED_OBJECT: (state, object) => {
    state.multipleRequestedObject = {
      ...state.multipleRequestedObject,
      ...object
    }
  },

  RESET_MULTIPLE_REQUESTED_OBJECT: state => {
    state.multipleRequestedObject = {
      City: [],
      PostalCode: [],
      StreetNumber: [],
      StreetName: [],
      MLSNumber: [],
      Keywords: ''
    }
  },

  SET_SEARCH_TEXT_PARAMS: (state, object) => {
    state.searchTextParams = { ...state.searchTextParams, ...object }
  },

  RESET_SEARCH_TEXT_PARAMS: state => {
    state.searchTextParams = {}
  },
  // ************************************************
  // ************************************************

  SET_LOADING: state => {
    Object.assign(state.authStatus, {
      loading: true
    })
  },

  SET_LOGIN_STATUS: (state, payload) => {
    Object.assign(state.authStatus, {
      isLoggedIn: payload['status'],
      loginError: payload['message'],
      errorAlert: payload['error'],
      loading: false
    })
  },

  SET_SELECTED_HOME: (state, payload) => {
    state.selectedHome = payload
  },

  SET_LOADING_ROUTES: (state, payload) => {
    state.loadingRoutes = payload
  },

  SET_EXPANDED_ROUTE: (state, payload) => {
    state.expandedRoute = payload
  },

  SET_PERSON_NAME: (state, payload) => {
    state.personName = payload
  },

  DEACTIVATE_ERROR_STATUS: state => {
    Object.assign(state.authStatus, {
      loginError: null,
      errorAlert: false
    })
  },

  SET_PROFILE_STATUS: (state, payload) => {
    state.profileStatus = payload
    localStorage.setItem('profileStatus', payload)
  },

  CLEAR_LAST_NEW_QUERY: state => {
    state.lastNewQuery = { ...getDefaultCommonState().lastNewQuery }
  },

  SET_NEW_REQUESTED_QUERY: (state, payload) => {
    Object.assign(state.lastNewQuery, {
      query: payload
    })
  },

  REFRESH_SEARCH_PAGE: (state, refreshState) => {
    state.refreshSearch = refreshState
  },

  SET_ROUTE_DATA: (state, payload) => {
    state.routeData = payload
  },

  ROUTES_LOADED: (state, status) => {
    state.routesLoaded = status
  },

  SET_SELECTED_ROUTE: (state, payload) => {
    state.selectedRoute = payload
  },

  SET_SELECTED_ROUTE_LOADING: (state, payload) => {
    state.selectedRouteLoading = payload
  },

  SET_ROUTE_HOMES: (state, payload) => {
    state.routeHomes = payload
  },

  SET_IS_MOBILE: (state, payload) => {
    state.isMobile = payload
  },

  SET_DEFAULT_COMMON_STATE: state => {
    Object.assign(state, getDefaultCommonState())
  },

  SET_SHOW_MOBILE_FEEDBACK_MODAL: (state, payload) => {
    state.showMobileFeedbackModal = payload
  },

  SET_SHOW_SINGLE_ROUTE_PROPERTY_VIEW: (state, payload) => {
    state.showSingleRoutePropertyView = payload
  },

  SET_DRAWER_STATE: (state, payload) => {
    state.drawer = payload
  },
  SET_SELECTED_FAVORITES_TAB: (state, payload) => {
    state.selectedFavoritesTab = payload
  },

  SET_DO_SCROLL: (state, payload) => {
    state.doScroll = payload
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
